/**
 * Returns a list with auxiliaries for the Spanish passive voice assessment.
 * @returns {Array} The list with auxiliaries.
 */
export default [
	"ser",
	"soy",
	"eres",
	"es",
	"somos",
	"sois",
	"son",
	"fui",
	"fuiste",
	"fue",
	"fuimos",
	"fuisteis",
	"fueron",
	"era",
	"eras",
	"era",
	"éramos",
	"erais",
	"eran",
	"sería",
	"serías",
	"seríamos",
	"seríais",
	"serían",
	"seré",
	"serás",
	"será",
	"seremos",
	"seréis",
	"serán",
	"seas",
	"sea",
	"seamos",
	"seáis",
	"sean",
	"fuera",
	"fueras",
	"fuéramos",
	"fuerais",
	"fueran",
	"fuese",
	"fueses",
	"fuésemos",
	"fueseis",
	"fuesen",
	"fuere",
	"fueres",
	"fuéremos",
	"fuereis",
	"fueren",
	"sé",
	"sed",
	"siendo",
	"sido",
];
